// All formatting functions go here (e.g. date, time, currency, full name etc.)

const toValidDate = (dateISO?: string | null) => {
  if (!dateISO) return;
  const date = dateISO ? new Date(dateISO) : new Date();
  if (!date || isNaN(date?.getTime())) {
    console.warn('Date is invalid', dateISO);
    return null;
  }
  return date;
};

export const localizeDate = (dateISO?: string | null, locale?: string) =>
  toValidDate(dateISO)?.toLocaleDateString(locale, { dateStyle: 'long' });

export const localizeDateTime = (dateISO?: string | null, locale?: string) =>
  toValidDate(dateISO)?.toLocaleString(locale, { dateStyle: 'long', timeStyle: 'short' });

const TICKS_PER_SECOND = 10_000_000;

export const formatTicksDuration = (ticks?: number | null) => {
  if (ticks === null || ticks === undefined) return;
  const totalSeconds = Math.round(ticks / TICKS_PER_SECOND);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  if (hours > 0) {
    return `${hours} h ${minutes} mn`;
  }
  if (minutes > 0) {
    return seconds > 0 ? `${minutes} mn ${seconds}s` : `${minutes} mn`;
  }
  return `${seconds}s`;
};

export const formatPercent = (value?: number | null) =>
  value === null || value === undefined ? '' : `${Math.round(value)}%`;
